var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconFont(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "a",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.83,19.1c-.37-.33-.83-1.15-1.4-2.44L12.46,3h-.67l-5.91,13.29c-.56,1.27-1.03,2.11-1.41,2.51-.38,.41-.87,.65-1.46,.74v.45h5.94v-.45c-.86-.06-1.4-.16-1.62-.29-.37-.22-.56-.57-.56-1.03,0-.35,.11-.8,.34-1.34l.38-.88h6.47l.56,1.33c.23,.54,.35,.85,.37,.92,.05,.16,.07,.31,.07,.45,0,.24-.09,.43-.27,.56-.26,.18-.71,.27-1.35,.27h-.33v.45h8v-.45c-.5-.04-.89-.19-1.17-.44ZM7.91,15l2.85-6.39,2.77,6.39H7.91Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFont);
export default __webpack_public_path__ + "static/1779968102/media/icon-font.7de569f2e15dd09a8ccabe2cd6052d2d.svg";
export { ForwardRef as ReactComponent };